import React, { createContext, useContext, useEffect, useState } from 'react';
import io from 'socket.io-client';
import { API_URL } from '../config/env';

const SocketContext = createContext(null);

export const useSocket = () => {
  const context = useContext(SocketContext);
  if (!context) {
    throw new Error('useSocket must be used within SocketProvider');
  }
  return context;
};

export const SocketProvider = ({ children }) => {
  const [socket, setSocket] = useState(null);
  const [isConnected, setIsConnected] = useState(false);

  useEffect(() => {
    // Socket.io needs the base URL without /api
    const backendUrl = API_URL.replace('/api', '').replace(/\/$/, '');

    console.log('🔌 Connecting to Socket.io server:', backendUrl);

    const newSocket = io(backendUrl, {
      transports: ['websocket', 'polling'],
      reconnection: true,
      reconnectionDelay: 1000,
      reconnectionAttempts: 5
    });

    newSocket.on('connect', () => {
      console.log('✅ Socket.io connected:', newSocket.id);
      setIsConnected(true);
    });

    newSocket.on('disconnect', () => {
      console.log('⚠️ Socket.io disconnected');
      setIsConnected(false);
    });

    newSocket.on('connect_error', (error) => {
      console.error('❌ Socket.io connection error:', error);
      console.error('Error details:', error.message);
      setIsConnected(false);
      // Don't throw error - socket is optional for app functionality
    });

    newSocket.on('error', (error) => {
      console.error('❌ Socket.io error:', error);
      // Don't throw error - socket is optional
    });

    setSocket(newSocket);

    return () => {
      console.log('🔌 Closing Socket.io connection');
      if (newSocket && newSocket.connected) {
        newSocket.close();
      }
    };
  }, []);

  return (
    <SocketContext.Provider value={{ socket, isConnected }}>
      {children}
    </SocketContext.Provider>
  );
};

